export const DataTable = ({ titles, children, className, type, style }) => {
  const length = titles.length
  const hasCustomGrid = style && style.gridTemplateColumns

  return (
    <>
      {/* titles */}
      <div
        className={`${className} grid ${
          hasCustomGrid ? "" : "grid-cols-" + length
        } py-4 text-lg [&>p:not(:last-child)]:pr-4`}
        style={style}
      >
        {titles.map((item, index) => (
          <p
            key={index}
            className={`whitespace-nowrap  overflow-hidden text-ellipsis w-full font-medium text-[#A4AFBD]${
              type !== "transaction" ? " last:text-start" : ""
            }`}
          >
            {item}
          </p>
        ))}
      </div>

      {/* body */}
      {children}
    </>
  )
}
